export const DEFAULT_PAGE_SIZE = 10;
export const GOOGLE_MAPS_API_KEY = "AIzaSyC98Ydz_EyBJpc47rLyjmjveU4i7_pb03A";
export const GOOGLE_MAPS_LIBRARIES = ["drawing", "places", "marker"];

export const FILTER_PAGE = {
  METER: "METER",
  AWAITING_TESTING: "AWAITING_TESTING",
  AWAITING_PREPARATION: "AWAITING_PREPARATION",
  AWAITING_TESTING_CONFIG: "AWAITING_TESTING_CONFIG",
  READY_FOR_REPAIR: "READY_FOR_REPAIR",
  MAINTENANCE_REPORTS: "MAINTENANCE_REPORTS",
  METER_BOX: "METER_BOX",
  SIM_CARDS: "SIM_CARDS",
  SIM_CARD_REPORTS: "SIM_CARD_REPORTS",
  STOVE_REPAIR: "STOVE_REPAIR",
  PRICE: "PRICE",
  CONSUMPTION_BAND: "CONSUMPTION_BAND",
  CUSTOMER_PRICE_GROUPS: "CUSTOMER_PRICE_GROUPS",
  CUSTOMER_BLACKLIST: "CUSTOMER_BLACKLIST",
  GAS_BUNDLES: "GAS_BUNDLES",
  PRICES: "PRICES",
  TASK: "TASK",
  TASK_CANCELLED: "TASK_CANCELLED",
  TASK_INVESTIGATION: "TASK_INVESTIGATION",
  TASK_INTERVENTION: "TASK_INTERVENTION",
  TASK_REQUESTS: "TASK_REQUESTS",
  CUSTOMER_UPDATE_REQUESTS: "CUSTOMER_UPDATE_REQUESTS",
  VALIDATION_TASK_REQUESTS: "VALIDATION_TASK_REQUESTS",
  TASK_ARCHIVE: "TASK_ARCHIVE",
  REFUND_REQUESTS: "REFUND_REQUESTS",
  OUTGOING_LOGS: "OUTGOING_LOGS",
  ROUTINE_TASK: { Open: "ROUTINE_TASK", Close: "ROUTINE_CLOSED", Suspended: "ROUTINE_SUSPENDED" },
  ASSET: "ASSET",
  CUSTOMERS: "CUSTOMERS",
  USERS: "USERS",
  REPOSSESSED_CUSTOMERS: "REPOSSESSED_CUSTOMERS",
  SUSPENDED_CUSTOMERS: "SUSPENDED_CUSTOMERS",
  LEADS: "LEADS",
  NOT_ASSIGNED_LEADS: "NOT_ASSIGNED_LEADS",
  PROSPECTS: "PROSPECTS",
  COOKING_SESSION: "COOKING_SESSION",
  PACKAGES: "PACKAGES",
  UNPROCESSED_PAYMENTS: "UNPROCESSED_PAYMENTS",
  FAILED_PAYMENTS: "FAILED_PAYMENTS",
  DEPOT: "DEPOT",
  TEAMS: "TEAMS",
  CUSTOMERS_TRANSACTION_BOOK: "CUSTOMERS_TRANSACTION_BOOK",
  CYLINDER_REPAIR: "CYLINDER_REPAIR",
  FROM_MARKET_REPORTS: "FROM_MARKET_REPORTS",
  TO_MARKET_REPORTS: "TO_MARKET_REPORTS",
  ASSET_REQUEST_HISTORY: "ASSET_REQUEST_HISTORY",
  TAM_REQUESTS: "TAM_REQUESTS",
  STO: "STO",
  TRIP: "TRIP",
  LB: "LB",
  SURVEY: "SURVEY",
  VEHICLE: "VEHICLE",
  CAMPAIGN: "CAMPAIGN",
  CONTRACT_VERSIONS: "CONTRACT_VERSIONS",
  MARKETING_INITIATIVES: "MARKETING_INITIATIVES",
  FIRMWARE_UPDATE_PROCESSES: "FIRMWARE_UPDATE_PROCESSES",
  METERS_FIRMWARE_HISTORY: "METERS_FIRMWARE_HISTORY",
  ASSETS_IN_TRUCK: "ASSETS_IN_TRUCK",
  MT_BOXES: "MT_BOXES",
  MT_PALLETS: "MT_PALLETS",
  MT_ORDERS: "MT_ORDERS",
  BATTERY_TEMPLATES: "BATTERY_TEMPLATES",
  BATTERIES: "BATTERIES",
  CALIBRATION_TEMPLATES: "CALIBRATION_TEMPLATES",
  CALIBRATION_REPORTS: "CALIBRATION_REPORTS",
  QUARANTINE_METERS: "QUARANTINE_METERS",
  STUCK_METERS: "STUCK_METERS",
  DECOMMISSIONED_METERS: "DECOMMISSIONED_METERS",
  CUSTOMER_CARDS: "CUSTOMER_CARDS",
  SMART_SCALE: "SMART_SCALE",
};

export const USER_ROLES = {
  SYSTEM_FULL_ADMINS: "SystemFullAdmins",
  PRODUCT_TECHNICIANS: "ProductTechnicians",
  PRODUCT_TECHNICIAN_LEAD: "ProductTechLeadership",
  SYSTEM_SUPPORT: "SystemSupport",
  WAREHOUSE: "Warehouse",
  OPERATION_MANAGERS: "OperationManagers", //DSM, ADSM
  DEPOT_CLERK: "DepotClerk", //DSC
  A_SM: "ASM",
  SALES: "Sales",
  CUSTOMER_CARE: "CustomerCare",
  CUSTOMER_CARE_LEADERSHIP: "CustomerCareLeadership",
  TRAINING: "Training",
  INTERNAL_AUDITOR: "InternalAuditor",
  TECHNICIANS: "Technicians",
  TSS: "TSS",
  MTSR: "MobileTechnicians",
  GENERAL: "General",
  IT_OPERATIONS: "ITOperations",
  IT_OPERATIONS_LEADERSHIP: "ITOperationsLeadership",
  BUSINESS_DEV: "BusinessDev",
  FINANCE: "Finance",
  LOGISTICS: "Logistics",
  SECURITY: "Security",
  METER_ENGINEER: "MeterEngineer",
  METER_ENGINEER_LEADERSHIP: "MeterEngineerLeadership",
  LT: "Riders",
  MDSC: "MDSC",
  MMT: "MMT",
  MWT: "MWT",
  CX_INTEGRATION: "CXIntegration",
};

export const AUTH_USER = () => JSON.parse(localStorage.getItem("b2c:authUser") || "{}");
export const USER_DEPOT_DATA = () => JSON.parse(localStorage.getItem("b2c:userDepotData") || "{}");
export const USER_CURRENCY = () => localStorage.getItem("b2c:userCurrency");
export const NATIONAL_ID_LENGTH_MIN = () => localStorage.getItem("b2c:minNationalIdLength") || 8;
export const NATIONAL_ID_LENGTH_MAX = () => localStorage.getItem("b2c:maxNationalIdLength") || 9;
export const USER_TENANT_NAME = () => localStorage.getItem("b2c:userTenantName");
export const USER_TENANT = () => localStorage.getItem("b2c:userTenant");
export const TENANT_PHONE_MASK = () => localStorage.getItem("b2c:phonePlaceholder") || "***";

export const USER_LIST_PARAMS = {
  role: [USER_ROLES.TECHNICIANS, USER_ROLES.MTSR].join(),
  depot: AUTH_USER()?.depotName,
  pageSize: 500,
};

export const ENGINE_VERSION = {
  V1: "v1",
  V2: "v2",
  V3: "v3",
};

export const CSV_TEMPLATES = {
  BULK_REMOVE_QUARANTINE: {
    fileName: "Bulk Remove from Quarantine Template",
    headers: ["meterBarcode"],
  },
  BULK_METERS_UNMOUNT: {
    fileName: "Bulk Unmount Meters from Cylinder Template",
    headers: ["meterBarcode"],
  },
  BULK_METERS_RETIRE: {
    fileName: "Bulk Retire Meters Template",
    headers: ["meterBarcode"],
  },
  BULK_METERS_ATFM_NR: {
    fileName: "Bulk Retire Meters Template",
    headers: ["meterBarcode"],
  },
  CREATE_NEW_BULK_SMS: {
    fileName: "Create new Bulk SMS Template",
    headers: ["Phone"],
  },
  CUSTOMER_BULK_LINK_TSR: {
    fileName: "Bulk link customers to TSR Template",
    headers: ["customerId"],
  },
  CUSTOMER_BULK_LINK_DEPOT: {
    fileName: "Bulk link customers to Depot Template",
    headers: ["customerId", "tsr", "tsrName", "growthTsr", "growthTsrName"],
  },
  UPLOAD_VEHICLES: {
    fileName: "Upload Vehicles Template",
    headers: ["UNIT", "UNIT TYPE", "ASSIGNED NO", "DEPOT"],
  },
  ADD_BATTERIES: {
    fileName: "Add Batteries Template",
    headers: ["serial"],
  },
  NEW_BULK_TAM: {
    fileName: "New bulk TAM request Template",
    headers: [],
  },
  UPLOAD_METERS_PX_ALL: {
    fileName: "Upload PX Meters All Fields Template",
    headers: [
      "meterBarcode",
      "serial",
      "type",
      "pcb",
      "sensorSerial",
      "sensorType",
      "simCardSlotsNumber",
      "simCardTypes",
      "firmware",
      "controller",
      "batteryModel",
      "batteries",
      "maxBatteryVoltage",
      "minBatteryVoltage",
      "calibratedAt",
      "manufactureName",
      "manufactureLocation",
      "embeddedSimCardIccid",
      "removableSimCardIccid",
      "modemMac",
      "bleMac",
      "assemblyDate",
      "certId",
      "controller2",
      "mcu2Firmware",
      "modemFirmware",
      "sensorFwVersion",
      "sensorHwVersion",
      "batteryCapacity",
    ],
  },
  UPLOAD_METERS_PX_MANDATORY: {
    fileName: "Upload PX Meters Mandatory Fields Template",
    headers: ["meterBarcode", "type", "pcb", "controller", "assemblyDate"],
  },
  UPLOAD_METERS_P4_ALL: {
    fileName: "Upload P4 Meters All Fields Template",
    headers: [
      "meterBarcode",
      "serial",
      "type",
      "pcb",
      "sensorSerial",
      "sensorType",
      "simCardSlotsNumber",
      "simCardTypes",
      "firmware",
      "controller",
      "batteryModel",
      "batteries",
      "maxBatteryVoltage",
      "minBatteryVoltage",
      "calibratedAt",
      "manufactureName",
      "manufactureLocation",
      "embeddedSimCardIccid",
      "removableSimCardIccid",
    ],
  },
  UPLOAD_METERS_P4_MANDATORY: {
    fileName: "Upload P4 Meters Mandatory Fields Template",
    headers: [
      "meterBarcode",
      "serial",
      "type",
      "pcb",
      "sensorSerial",
      "sensorType",
      "simCardSlotsNumber",
      "simCardTypes",
      "firmware",
      "controller",
      "batteryModel",
      "maxBatteryVoltage",
      "minBatteryVoltage",
      "calibratedAt",
    ],
  },
  NEW_BULK_SMS: {
    fileName: "Create new Bulk SMS Template",
    headers: ["phoneNumber"],
  },
  SHIP_METERS: {
    fileName: "Ship Meters from factory to depots Template",
    headers: ["meterBarcode"],
  },
  UPLOAD_SIM_CARDS: {
    fileName: "Upload SIM Cards Template",
    headers: [
      "msisdn",
      "iccid",
      "ip",
      "imsi",
      "simType",
      "imei",
      "networkWhitelist",
      "imeiLock",
      "simConnector",
      "isActivated",
      "networkName",
      "networkCountry",
      "networkCountryCode",
      "networkMCC",
      "networkMNC",
    ],
  },
  UPLOAD_SIM_CARDS_REPORTS: {
    fileName: "Upload SIM Cards status updates Template",
    headers: ["iccid"],
  },
  SEND_METER_COMMANDS: {
    fileName: "Send Meter Commands Template",
    headers: ["barcode"],
  },
  EDIT_SEGMENTS: {
    fileName: "User list segments Template",
    headers: ["customerId"],
  },
  NEW_CUSTOMER_GROUP: {
    fileName: "Customer Group Template",
    headers: ["customerNumber"],
  },
  ADD_REMOVE_CUSTOMERS_GROUP: {
    fileName: "Add/Remove Customers from Group Template",
    headers: ["customerNumber"],
  },
  ADD_CUSTOMERS_BLACKLIST: {
    fileName: "Add/Remove Customers to Blacklist Template",
    headers: ["customerId"],
  },
  METER_CALIBRATION: {
    fileName: "Meter Calibration Template",
    headers: ["barcode"],
  },
  BULK_FIRMWARE_UPDATE: {
    fileName: "Send Bulk Meter Firmware Template",
    headers: ["meterBarcode", "newFirmware", "mcuType"],
  },
  BULK_METER_VALIDATE: {
    fileName: "Bulk Meter Validation Template",
    headers: ["meterBarcode"],
  },
  CAMPAIGN_USERS_TEMPLATE: {
    fileName: "Upload Campaign Users Template",
    headers: ["customerId"],
  },
  CUSTOMER_CONVERT: {
    fileName: "Customer category convert",
    headers: ["customerId"],
  },
};
